import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form/immutable';
import { routerReducer } from 'react-router-redux';
import { fromJS } from 'immutable';

import userHandlerReducer from './containers/user-handler/reducer';
import userReducer from './containers/user-widget/reducer';
import campaignListReducer from './containers/influencers-campaign-list/reducer';
import campaignReducer from './containers/campaign/reducer';
import statusBarReducer from './containers/status-bar/reducer';
import campaignInviteReducer from './containers/campaign-invite/reducer';
import discussionReducer from './containers/discussion/reducer';
import discussionListReducer from './containers/discussion-list/reducer';
import campaignMembersReducer from './containers/campaign-members-manage/reducer';
import deliverableReducer from './containers/deliverable/reducer';
import analyticsAssetListReducer from './containers/analytics-asset-list/reducer';
import userProfileReducer from './containers/user-profile/reducer';
import userSettingsReducer from './containers/user-settings/reducer';
import influencersReducer from './containers/influencers/reducer';
import deliverableSubmitReducer from './containers/deliverable-submit-modal/reducer';
import deliverableAssignReducer from './containers/deliverable-assign-modal/reducer';
import campaignAnalyticsReducer from './containers/campaign-analytics/reducer';
import analyticsAssetReducer from './containers/analytics-asset/reducer';
import paymentsReducer from './containers/payments/reducer';
import trackAssetModalRedcuer from './containers/track-asset-modal/reducer';
import userOnboardingReducer from './containers/user-onboarding-state/reducer';

import sendbirdReducer from './reducers/sendbird';
import modalReducer from './reducers/modal';

import {
  WINDOW_RESIZE,
} from './constants';

const initialWindowSizeState = fromJS({
  windowWidth: 0,
  windowHeight: 0,
});

function windowSizeReducer(state = initialWindowSizeState, action) {
  switch (action.type) {
  case WINDOW_RESIZE:
    return state
      .set('windowWidth', action.windowWidth)
      .set('windowHeight', action.windowHeight);
  default:
    return state;
  }
}

const reducers = {
  windowSize: windowSizeReducer,
  user: userHandlerReducer,
  userData: userReducer,
  campaignList: campaignListReducer,
  campaign: campaignReducer,
  members: campaignMembersReducer,
  discussionList: discussionListReducer,
  discussion: discussionReducer,
  statusBar: statusBarReducer,
  form: formReducer,
  invite: campaignInviteReducer,
  modal: modalReducer,
  routing: routerReducer,
  deliverable: deliverableReducer,
  analyticsAssetList: analyticsAssetListReducer,
  userProfile: userProfileReducer,
  userSettings: userSettingsReducer,
  influencers: influencersReducer,
  deliverableSubmit: deliverableSubmitReducer,
  deliverableAssign: deliverableAssignReducer,
  campaignAnalytics: campaignAnalyticsReducer,
  analyticsAsset: analyticsAssetReducer,
  payments: paymentsReducer,
  trackAssetModal: trackAssetModalRedcuer,
  userOnboarding: userOnboardingReducer,
};

const reducer = combineReducers(reducers);

export default reducer;



/** WEBPACK FOOTER **
 ** ./src/reducer.js
 **/